import React, { useState } from 'react';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import styled from '@emotion/styled';

import DatePicker from 'react-datepicker';
import getResponse from '../../utilities/FetchHelper';
import configuration from '../../config';
import LowerUpperMode from './LowerUpperMode';
import StartEndTime from './StartEndTime';

const ComfortModalScheduleEvent = ({
  onClose,
  zoneData,
  updateZoneData,
  setShowLoading,
  errorMessage,
  setErrorMessage,
  errorMessageRef,
}) => {
  const newDate = new Date();
  let year = newDate.toLocaleString('default', { year: 'numeric' });
  let month = newDate.toLocaleString('default', { month: '2-digit' });
  let day = newDate.toLocaleString('default', { day: '2-digit' });
  let formattedDate = year + '-' + month + '-' + day;

  const [startDate, setStartDate] = useState(newDate);
  const [postData, setPostData] = useState({
    eventName: `New Event: ${formattedDate}`,
    date: formattedDate,
    startTime: '06:00',
    endTime: '14:30',
    lowerBound: 68,
    upperBound: 75,
    blockCooling: false,
    blockHeating: false,
  });

  const handleChange = (index = null, name, value) => {
    if (name === 'lowerBound') {
      setPostData((prevState) => ({ ...prevState, lowerBound: value }));
    } else if (name === 'upperBound') {
      setPostData((prevState) => ({ ...prevState, upperBound: value }));
    } else if (name === 'heat') {
      setPostData((prevState) => ({ ...prevState, blockCooling: true, blockHeating: false }));
    } else if (name === 'cool') {
      setPostData((prevState) => ({ ...prevState, blockCooling: false, blockHeating: true }));
    } else if (name === 'fan') {
      setPostData((prevState) => ({ ...prevState, blockCooling: true, blockHeating: true }));
    } else if (name === 'auto') {
      setPostData((prevState) => ({ ...prevState, blockCooling: false, blockHeating: false }));
    }

    if (name === 'startTime') {
      setPostData((prevState) => ({ ...prevState, startTime: value }));
    } else if (name === 'endTime') {
      setPostData((prevState) => ({ ...prevState, endTime: value }));
    }
  };

  const handleDateSelect = (selectedDate) => {
    let newDay =
      selectedDate.getDate() < 10 ? `0${selectedDate.getDate()}` : selectedDate.getDate();
    let indexMonth = selectedDate.getMonth() + 1;
    let newMonth = indexMonth < 10 ? `0${indexMonth}` : indexMonth;

    setStartDate(selectedDate);
    setPostData((prevState) => ({
      ...prevState,
      date: selectedDate.getFullYear() + '-' + newMonth + '-' + newDay,
    }));
  };

  const handleSave = () => {
    setShowLoading({ message: 'Creating event...', isLoading: true });
    const clearLoading = () => setShowLoading({ message: '', isLoading: false });

    const encodeGetParams = (p) =>
      Object.entries(p)
        .map((item) => item.map(encodeURIComponent).join('='))
        .join('&');

    getResponse(
      configuration['backend_host'] +
        '/ahiapi/' +
        zoneData.thermalZoneEntityKey +
        '/thermalZone/event',
      false,
      'POST',
      encodeGetParams(postData),
      updateZoneData,
      clearLoading,
      errorMessage,
      setErrorMessage,
      errorMessageRef
    );
    onClose();
  };

  return (
    <StyledScheduleEventDiv className="modal-homepage-zone-settings desktop">
      <div className="home-schedule-event-fields-container">
        <div className="frm-field-container">
          <label>
            Event Name
            <div>
              <input
                type="text"
                name="event_name"
                maxLength="30"
                placeholder={`New Event: ${formattedDate}`}
                onChange={(e) =>
                  setPostData((prevState) => ({
                    ...prevState,
                    eventName: e.target.value.replace(/\s/g, '+'),
                  }))
                }
              />
            </div>
          </label>
        </div>
        <div className="frm-field-container">
          <label>
            Date
            <div className="date-input-container">
              <DatePicker selected={startDate} onChange={(date) => handleDateSelect(date)} />
            </div>
          </label>
        </div>
        <StartEndTime handleChange={handleChange} />
        <LowerUpperMode handleChange={handleChange} />
      </div>

      <div className="modal-actions">
        <button className="modal-btn" onClick={onClose}>
          Cancel
        </button>
        <button className="modal-btn cta" onClick={handleSave}>
          Confirm
        </button>
      </div>
    </StyledScheduleEventDiv>
  );
};

const StyledScheduleEventDiv = styled.div`
  .home-schedule-event-fields-container {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    column-gap: 24px;

    .frm-field-container,
    .time-container {
      padding-bottom: 24px;
    }

    .frm-field-container,
    .frm-field-container input {
      width: 100%;
      z-index: 10;
    }

    .frm-field-container label > div {
      padding-top: 12px;
    }

    .time-container,
    .lowerUpperMode-container {
      height: 173px;
    }

    .time-container {
      margin-right: 24px;
      width: 50%;

      .start-time-container {
        padding-bottom: 24px;
      }
    }

    .lowerUpperMode-container {
      width: 35%;

      .mode-container {
        padding: 0;
      }
    }
  }

  .modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
  }

  @media screen and (max-width: 768px) {
    .home-schedule-event-fields-container {
      .time-container,
      .lowerUpperMode-container {
        margin-right: 0;
        width: 100%;
      }
    }
  }
`;

export { ComfortModalScheduleEvent };
export default ComfortModalScheduleEvent;
